<template>
  <div>
    <van-nav-bar placeholder title="我的意见" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
      </template>
    </van-nav-bar>
    <!--列表-->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()" style="min-height: 100vh">
      <van-list
              v-model="data.bottomLoading"
              :finished="!data.hasMore"
              finished-text="没有更多了"
              @load="bottomRefresh()"
      >
        <div class="idea-box" v-for="(item, index) in data.records" :key="index" @click="toDetail(item)">
          <div class="idea-top">
            <h2>意见类型：<b>{{getDictName(ideaTypeOptions, item.ideaType)}}</b></h2>
            <span class="yhf" v-if="item.replyUserId">已回复</span>
            <span class="dhf" v-else>待回复</span>
          </div>
          <div class="time">提出时间：<b>{{item.ideaTime}}</b></div>
          <div class="time" v-if="item.replyTime">回复时间：<b>{{item.replyTime}}</b></div>

        </div>
      </van-list>
    </van-pull-refresh>

    <!--悬浮-->
    <div style="height:60px"></div>
    <button class="floatbox" @click="toAdd">添加</button>

  </div>
</template>

<script>
  import {getDictByType} from '@/api/common'
  import {getDictName} from '@/utils/common'
  import {queryList} from '@/api/my/idea'
  import {handlePageData} from '@/utils/common'

  export default {
    name: 'ideaIndex',
    components: {},
    data() {
      return {
        getDictName,
        queryParams: {},
        data: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
        ideaTypeOptions: []
      }
    },
    computed: {},
    created() {
      this.getDict()
      this.refresh()
    },
    mounted() {
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      refresh() {
        this.reset()
        this.getList()
      },
      bottomRefresh() {
        if (this.data.current > 1 && this.data.hasMore)
          this.getList()
      },
      reset() {
        this.data.current = 1
        this.data.total = 0
        this.data.hasMore = true
      },
      getList() {
        if (this.data.loading) return
        this.data.loading = true
        this.queryParams.current = this.data.current
        this.queryParams.size = this.data.size

        queryList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.data, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.data.loading = false
            this.data.topLoading = false
            this.data.bottomLoading = false
          }, 100)
        })
      },
      getDict() {
        // 查询字典，意见类型
        getDictByType('idea_type').then(res => {
          if (res.code === 10000) {
            this.ideaTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
      toDetail(item) {
        this.$router.push({path: `/my/ideaDetail?id=${item.id}`});
      },
      toAdd() {
        this.$router.push({path: `/my/ideaAdd`});
      }
    }
  }
</script>

<style scoped>
  /deep/.van-list{
    padding: 10px;
  }
  .idea-box {
    background: #F4F5F7;
    border-radius:12px;
    margin-bottom: 10px;
    padding: 16px;
  }
.idea-top{
  display: flex;
  height: 24px;
  align-items: center;
  justify-content: space-between;
  flex: none;
  flex-grow: 0;
  gap: 10px;
}
.idea-top h2{
  display: flex;
  height:14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #777777;
  line-height:14px;
}
.idea-top h2 b{
    display: flex;
    height:14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height:14px;
  }
.idea-top span{
  display: flex;
  align-items: center;
  justify-content: center;
  width:58px;
  height:24px;
  border-radius:100px;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
  .idea-top span.dhf{
    border: 1px solid #FF0000;
    color: #FF0000;
  }
  .idea-top span.yhf{
    border: 1px solid #A7A7A7;
    color:#A7A7A7;
  }
  .time{
    height:14px;
    font-size:14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 0px;
    color:#777777 ;
    margin-top:16px;
  }
  .time b{
    color: #000000;
  }
</style>
